import { Heart, HeartFilled } from '@ori-ui/icons';
import { Filled, HeartIconRoot, Outlined } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HeartIcon = function HeartIcon(_ref) {
  var isFavorite = _ref.isFavorite;
  return /*#__PURE__*/_jsxs(HeartIconRoot, {
    children: [/*#__PURE__*/_jsx(Filled, {
      isFavorite: isFavorite,
      className: "filledIcon",
      children: /*#__PURE__*/_jsx(HeartFilled, {
        fontSize: "inherit"
      })
    }), /*#__PURE__*/_jsx(Outlined, {
      isFavorite: isFavorite,
      className: "outlinedIcon",
      children: /*#__PURE__*/_jsx(Heart, {
        fontSize: "inherit"
      })
    })]
  });
};
//# sourceMappingURL=HeartIcon.js.map